import Vue from 'vue'

export const EventBus = new Vue()

export const events = {
    SNACKBAR: 'SNACKBAR',
}
